import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { clearVelocitySummaryData } from "../../audiencesManagerActions";
import VelocitySummaryModal from "../VelocitySummaryModal";

export default function CDVelocitySummaryModal({ onClose }) {
  const { velocitySummary, searchAudienceFilters } = useSelector(
    (state) => state.audiencesManagerReducer,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearVelocitySummaryData());
    };
  }, [dispatch]);

  return (
    <VelocitySummaryModal
      onClose={onClose}
      velocitySummary={velocitySummary}
      searchAudienceFilters={searchAudienceFilters}
    />
  );
}
